import React, { Component } from 'react'

export class NotFoundRoute extends Component {
  constructor() {
    super()
  }

  render() {
    return <div>Module Not Found</div>
  }
}

export default NotFoundRoute



// WEBPACK FOOTER //
// ./src/modules/NotFound/Routes/NotFoundRoute/NotFoundRoute.js